export enum PermissionCode  {
    getMe = "get_me",
    userGenerateTotp = "user_generate_totp",
    userEnableTotp = "user_enable_totp",
    userDisableTotp = "user_disable_totp",
    userChangePassword = "user_change_password",

    adminUserCreateNewUser = "admin_user_create_new_user",
    adminUserDeleteUser = "admin_user_delete_user",
    adminUserGetAllUsers = "admin_ser_get_all_users",
    adminUserChangePasswordOfUser = "admin_user_change_password_of_user",
    adminUserUpdateUse = "admin_user_update_user",
    adminUserGetUserById = "admin_user_get_user_by_id",

    createApplication = "create_application",
    getAllApplication = "get_all_application",
    getApplicationById = "get_application_by_id",
    deleteApplication = "delete_application",

    updateConfigMap = "update_config_map",
    getAllConfigMap = "get_all_config_map",
    getConfigMapByCode = "get_config_map_by_code",

    updateEventRisk = "update_event_risk",
    getAllEventRisk = "get_all_event_risk",
    getEventRiskById = "get_event_risk_by_id",

    getAllRole = "get_all_role",
    createNewRole = "create_new_role",
    updateRole = "update_role",
    deleteRole = "delete_role",
    getAllPermission = "get_all_permission",
    getPermissionOfRole = "get_permission_of_role",

    getAllLogPlatform = "get_all_log_platform",
    updateLogPlatform = "update_log_platform",

    getDashboardMapData = "get_dashboard_map_data",
    getDashboardRiskPerDayData = "get_dashboard_risk_per_day_data",
    getDashboardTopRiskDevice = "get_dashboard_top_risk_device",
    getDashboardTopRiskDeviceModel = "get_dashboard_top_risk_device_model",
    getDashboardTopRiskAppVersion = "get_dashboard_top_risk_app_version"
,   getDashboardEventCountPerEventTypeData = "get_dashboard_event_count_per_event_type",
    getDistinctValueOfFiled = "get_distinct_value_of_filed",
    getReport = "get_report",

    createExport = "create_export",
    getAllExports = "get_all_exports",

    createAlertReceiver = "create_alert_receiver",
    updateAlertReceiver = "update_alert_receiver",
    getAllAlertReceiver = "get_all_alert_receiver",
    deleteAlertReceiver = "delete_alert_receiver",

    createAlertRule = "create_alert_rule",
    updateAlertRule = "update_alert_rule",
    getAllAlertRule = "get_all_alert_rule",
    deleteAlertRule = "delete_alert_rule",

    getSystemHealth = "get_system_health"
}